import { createContextForClass } from 'bz-utilities/hooks/context-v2';
import CacheStore from 'bz-utilities/modules/stores/cached-map-store';

import { computed } from 'mobx';
import { computedFn } from 'mobx-utils';

import type { EquipmentEntry } from 'tm3-core/api.dtos';
import { EEquipmentStatus } from 'tm3-core/api.dtos';

class EquipmentCacheStore extends CacheStore<EquipmentEntry> {
  constructor() {
    super('equipment');
  }

  @computed
  get Current() {
    return this.All.filter((x) => x.status == EEquipmentStatus.Active);
  }

  ById(id: number | string): EquipmentEntry | undefined {
    return id == null ? undefined : this._ById(id);
  }

  ByLocation(locationId: number) {
    return locationId == null ? undefined : this._ByLocation(locationId);
  }

  ByRoom(id?: number | string) {
    return id == null ? undefined : this._ByRoom(id);
  }

  protected readonly _ById = computedFn((id: number | string): EquipmentEntry | undefined => {
    if (Number.isNumber(id)) {
      return this._ById(id);
    }

    return Number.isNumber(id) ? this._ById(id) : this._all.get(id);
  });

  protected readonly _ByRoom = computedFn((id: number | string): EquipmentEntry[] => {
    if (String.isString(id)) {
      return this._ByRoom(id.toInt());
    }

    return this.Current.filter((x) => x.roomId === id);
  });

  protected readonly _ByLocation = computedFn((id: number | string): EquipmentEntry[] => {
    if (String.isString(id)) {
      return this._ByLocation(id.toInt());
    }

    return this.Current.filter((x) => x.locationId === id);
  });
}

export const [EquipmentCacheStoreCtx, useEquipmentCacheStore] =
  createContextForClass(EquipmentCacheStore);

export default EquipmentCacheStore;
